import { stringToLowerCase } from '../global/js/helper/stringToLowerCase';

export class RegistrationService {
    static register(email, formName, plan = 'pro', promocode, addons, packages, source, registrationType, template) {
        return new Promise((resolve, reject) => {
            const registration = new WG.RebrandingRegistration({
                fields: {
                    registrationType: true,
                    licenseId: true,
                },
            });

            plan = stringToLowerCase(plan);

            registration.setOptions({
                locale: window.wrike.locale,
                fields: {
                    registrationType: registrationType,
                    source: source,
                    promoCode: promocode,
                    packages: packages,
                    addons: addons,
                    plan: plan,
                    template: template,
                },
            });
            registration
                .register(email, formName, plan)
                .then((response) => {
                    registration.signupSuccessHandler(response);
                    resolve(response);
                })
                .fail((response) => {
                    reject(response);
                });
        });
    }

    static registerNewContract(email, formName, plan, addons, packages, source, template, promocode, onboarding) {
        return new Promise((resolve, reject) => {
            const registration = new WG.RebrandingRegistrationNewContract();

            registration.setOptions({
                locale: window.wrike.locale,
                fields: {
                    plan: plan,
                    addons: addons,
                    packages: packages,
                    template: template,
                    source: source,
                    promoCode: promocode,
                    onboarding: onboarding,
                },
            });
            registration
                .register(email)
                .then((response) => {
                    registration.signupSuccessHandler(response);
                    resolve(response);
                })
                .fail((response) => {
                    reject(response);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/services/registration.js